import React, { useEffect, useRef, useState, useMemo } from "react";
import InputField from '../InputField'
import DropDown from '../DropDown'
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ButtonAdminpanel from "../ButtonAdminpanel";
import ImgUpload from "@/assets/images/webp/image-upload.webp";
import { default as ReactSelect } from "react-select";

import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
} from "ckeditor5";
import RadioButtonField from "../RadioButtonField";
import CheckBox from "../../components/CheckBox";
import SubHeader from "../SubHeader";
import { countryList } from "@/actions/countryAction";
import { connect } from "react-redux";
import { filter, forEach, includes, isEmpty, map, size, uniqBy } from "lodash";
import { getHSCodeList, getHSCodeSearchList, getQuantityUnitList, getCategories, getPortsByCountry, getSelectedHSCodeListByIdList } from "@/actions/defaultDataAction";
import { getProduct, updateProduct, deleteProductMedia, updateproductStatus } from "@/actions/productAction";
import { showSuccessMessage, showErrorMessage, getPrefix } from "@/utils/common";
import { useNavigate, useParams } from "react-router-dom";
import { privateRoutePaths } from "@/routes/private.route.config";
import { ToastContainer } from "react-toastify";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import errorMessages from "@/constant/errorMessages";
import { getCompanyListByTradeMode } from "@/actions/memberAction";
import defaultValues from "@/constant/defaultValues";
import SmallPopup from "@/components/SmallPopup";
import MediumPopup from "../MediumPopup";
import TextAreaField from "../TextAreaField";

function Index(props) {

  const { id } = useParams();
  const { BASE_URL } = defaultValues.IMAGE_PATH;

  const shippingTerms = ["EXW", "FOB", "FAS", "DPU", "DDP"];
  const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

  const mainImgRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const allHsCodesRef = useRef([]);

  const nav = useNavigate();

  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isSuperAdmin, isOpUser, memberCompanyID } = useAuth();

  const [errors, setErrors] = useState({});
  const [reject_error, setRejectError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [hscodeList, setHsCodeList] = useState([]);
  // const [categoryList, setCategoryList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  const [company, setCompany] = useState(null);

  const [product_description, setProductDescription] = useState('');


  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [deleteProductImageId, setDeleteImageId] = useState("");

  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [reasonModalShow, setReasonModalShow] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonTxt, setReasonTxt] = useState("");

 
  const [rawCategories, setRawCategories] = useState([]);

  const [selectIndustry,setSelectIndustry] = useState("");


  const [formData, setFormData] = useState({
    member_id: (user && (isPreKYCUser || isEndUser)) ? memberCompanyID : null,
    product_name: "",
    category: null,
    product_hs_code: null,
    product_origin_country: null,
    trading_area: [],
    shiiping_terms: [],
    price_type: "fixed",
    price: "",
    price_unit: "",
    minimum_order: "",
    product_desc: "",
    shipping_info: [{
      country: "",
      ports: [],
      portList: []
    }],
    medias: {
      main: {
        name: "",
        path: "",
        file: null
      },
      other_photos: []
    },
    product_status: -1
  });

  // const getPrefix = () => {
  //   if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
  //   if (user && isDemoUser) return roles.DEMO.prefix;
  //   if (user && isEndUser) return roles.END_USER.prefix;
  //   if (user && isViewer) return roles.VIEWER.prefix;
  //   return roles.SUPER_ADMIN.prefix;
  // };

  const handleInputChange = (e) => {
    setFormData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value
      }
    })
  }

  const customFilter = (option, searchTxt) => {
    /* if (!isEmpty(option.data.label)) {
      if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
        return true;
      }
    } */
    if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  const customMemberFilter = (option, searchTxt) => {
    if (option.data.email.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }


  const handleSelectChange = (val, field_name) => {
    if (field_name === "category") {
      setFormData((prev) => {
        return {
          ...prev,
          category: val
        }
      })
    }

    if (field_name === "hs_code") {
      setFormData((prev) => {
        return {
          ...prev,
          product_hs_code: val
        }
      })
    }

    if (field_name === "origin_country") {
      setFormData((prev) => {
        return {
          ...prev,
          product_origin_country: val
        }
      })
    }

    if (field_name === "price_unit") {
      setFormData((prev) => {
        return {
          ...prev,
          price_unit: val
        }
      })
    }

    if (field_name === "member_id") {
      setCompany(val);
      setFormData((prev) => {
        return {
          ...prev,
          member_id: val
        }
      })
    }
  }

  const handlehscodeInputChange = (val = "") => {
    if (!isEmpty(val) && size(val) > 3) {
      fetchHscode(val);
    } else {
      setHsCodeList(allHsCodesRef.current);
    }

  }

  const handleMemberInputChange = (val = "") => {
    if (val.length >= 3) {
      // console.log("API call ");
      fetchMembers(val);

    } else {
      fetchMembers("");
    }
  }

  const handleCheckChange = (e, val) => {
    const { checked } = e.target;
    if (val === "domestic" || val === "international") {
      if (checked) {
        setFormData((prev) => {
          return {
            ...prev,
            trading_area: [...formData.trading_area, val]
          }
        });
      } else {
        let oldTradingArea = [...formData.trading_area];
        oldTradingArea = filter(oldTradingArea, (v) => v != val);
        setFormData((prev) => {
          return {
            ...prev,
            trading_area: oldTradingArea
          }
        });
      }

    } else if (includes(shippingTerms, val)) {
      if (checked) {
        setFormData((prev) => {
          return {
            ...prev,
            shiiping_terms: [...formData.shiiping_terms, val]
          }
        });
      } else {
        let oldShippingTerms = [...formData.shiiping_terms];
        oldShippingTerms = filter(oldShippingTerms, (v) => v != val);
        setFormData((prev) => {
          return {
            ...prev,
            shiiping_terms: oldShippingTerms
          }
        });
      }
    }
  };

  const handlePriceTypeChange = (e) => {
    const newPriceType = e.target.value;

    setFormData((prev) => ({
      ...prev,
      price_type: newPriceType,
      price: newPriceType === "requestQuote" ? "" : prev.price,
      price_unit: newPriceType === "requestQuote" ? null : prev.price_unit,
    }));

    if (newPriceType === "requestQuote") {
      setErrors((prev) => ({
        ...prev,
        price: "",
        price_unit: "",
      }));
    }
  };

  // const handlePortChange = (newValue, indx) => {
  //   // setSelectedPorts(newValue);
  //   let sInfo = [...formData.shipping_info];
  //   sInfo[indx]['ports'] = newValue;
  //   setFormData((prev) => {
  //     return {
  //       ...prev,
  //       shipping_info: sInfo
  //     }
  //   })
  // };
  const handlePortChange = (newValue, indx) => {
    setFormData((prev) => {
      let sInfo = [...prev.shipping_info];
      sInfo[indx] = { ...sInfo[indx], ports: newValue };
      return { ...prev, shipping_info: sInfo }
    });
  };

  // const handleCountryChange = async (val, indx) => {
  //   //setSelectedCountrys(newValue);
  //   let countryId = val.value;
  //   let sInfo = [...formData.shipping_info];

  //   sInfo[indx]['country'] = val;
  //   await props.getPortsByCountry(countryId).then((response) => {
  //     const portOptions = map(response, (val) => {
  //       return {
  //         label: val.name,
  //         value: val.id
  //       }
  //     });
  //     sInfo[indx]['portList'] = portOptions;

  //   }).catch((err) => {
  //     console.log("Error ======== ", err);
  //   });

  //   setFormData((prev) => {
  //     return {
  //       ...prev,
  //       shipping_info: sInfo
  //     }
  //   })
  // }
  const handleCountryChange = async (val, indx) => {
    // Handle null when country is cleared (isClearable)
    if (!val) {
      setFormData((prev) => {
        let sInfo = [...prev.shipping_info];
        sInfo[indx] = {
          ...sInfo[indx],
          country: null,
          ports: null,
          portList: []
        };
        return { ...prev, shipping_info: sInfo }
      });
      return;
    }

    let countryId = val.value;

    setFormData((prev) => {
      let sInfo = [...prev.shipping_info];
      sInfo[indx] = {
        ...sInfo[indx],
        country: val,
        ports: null,
        portList: []
      };
      return { ...prev, shipping_info: sInfo }
    });

    await props.getPortsByCountry(countryId).then((response) => {
      const portOptions = map(response, (val) => ({
        label: val.name,
        value: val.id
      }));

      setFormData((prev) => {
        let sInfo = [...prev.shipping_info];
        sInfo[indx] = {
          ...sInfo[indx],
          portList: portOptions
        };
        return { ...prev, shipping_info: sInfo }
      });

    }).catch((err) => {
      console.log("Error ======== ", err);
    });
  }

  const handleImgClick = (e, val) => {

    if (val == "main") {
      mainImgRef.current.click();
    }

    if (val == "img1") {
      fileInputRef1.current.click();
    }

    if (val == "img2") {
      fileInputRef2.current.click();
    }

    if (val == "img3") {
      fileInputRef3.current.click();
    }

  }

  const handleAddClick = () => {
    setFormData((prev) => {
      return {
        ...prev,
        shipping_info: [...formData.shipping_info, {
          country: "",
          ports: [],
          portList: []
        }]
      }
    })
  }

  // const handleRemoveClick = (e, indx) => {
  //   let sInfo = [...formData.shipping_info];
  //   delete sInfo[indx];
  //   sInfo = filter(sInfo);
  //   if (isEmpty(sInfo)) {
  //     sInfo = [{
  //       country: "",
  //       ports: [],
  //       portList: []
  //     }]
  //   }
  //   setFormData((prev) => {
  //     return {
  //       ...prev,
  //       shipping_info: sInfo
  //     }
  //   })
  // }

  const handleRemoveClick = (e, indx) => {
    setFormData((prev) => {
      let sInfo = [...prev.shipping_info];
      sInfo.splice(indx, 1);
      if (isEmpty(sInfo)) {
        sInfo = [{ country: "", ports: [], portList: [] }];
      }
      return { ...prev, shipping_info: sInfo }
    });
  }

  // const handleFileChange = (e, fname) => {
  //   //console.log("handleFileChange >>>> ", e, " >>>>>>> fname <<<<<<<<<<<< ", fname);
  //   const file = e.target.files[0];
  //   //console.log("file >>>> ", file);
  //   let errObj = { ...errors };

  //   let error = "";
  //   if (file) {
  //     // Process the selected file (e.g., upload it or create a preview URL)
  //     //console.log('Selected file:', file.name);


  //     const fileData = {
  //       name: file.name,
  //       path: URL.createObjectURL(file),
  //       file: file,
  //     };

  //     if (!ALLOWED_TYPES.includes(file.type)) {
  //       // error = "Invalid file type. Only PDF, JPEG, and PNG are allowed."; // The file must be a file of type
  //       error = "The file must be a file of type jpg, png, jpeg or pdf";

  //     } else if (file.size > MAX_FILE_SIZE) {
  //       // error = "File size exceeds 2MB limit.";
  //       // console.log("File Size =============", file.size);
  //       error = "The file must be less than or equal to 2 MB";
  //     }

  //     if (error !== "") {
  //       if (fname === "main") {
  //         errObj.main_image = error;
  //         let medias = { ...formData.medias };

  //         medias['main']['name'] = "";
  //         medias['main']['path'] = "";
  //         medias['main']['file'] = null;

  //         setFormData((prev) => ({
  //           ...prev,
  //           medias: {
  //             ...prev.medias,
  //             main: fileData,
  //           },
  //         }));
  //       }
  //       if (fname === "img1") {
  //         errObj.img1 = error;
  //         let medias = { ...formData.medias };
  //         medias['other_photos']['img1'] = {};
  //         medias['other_photos']['img1']['name'] = "";
  //         medias['other_photos']['img1']['path'] = "";
  //         medias['other_photos']['img1']['file'] = null;

  //         setFormData((prev) => {
  //           return {
  //             ...prev,
  //             medias: medias
  //           }
  //         })

  //       }
  //       if (fname === "img2") {
  //         errObj.img2 = error;

  //         let medias = { ...formData.medias };
  //         medias['other_photos']['img2'] = {};
  //         medias['other_photos']['img2']['name'] = "";
  //         medias['other_photos']['img2']['path'] = "";
  //         medias['other_photos']['img2']['file'] = null;

  //         setFormData((prev) => {
  //           return {
  //             ...prev,
  //             medias: medias
  //           }
  //         })

  //       }
  //       if (fname === "img3") {
  //         errObj.img3 = error;

  //         let medias = { ...formData.medias };
  //         medias['other_photos']['img3'] = {};
  //         medias['other_photos']['img3']['name'] = "";
  //         medias['other_photos']['img3']['path'] = "";
  //         medias['other_photos']['img3']['file'] = null;

  //         setFormData((prev) => {
  //           return {
  //             ...prev,
  //             medias: medias
  //           }
  //         })
  //       }
  //       setErrors(errObj);

  //     }


  //     // You might use URL.createObjectURL(file) to generate an image preview

  //     if (error === "") {
  //       if (fname === "main") {

  //         let medias = { ...formData.medias };

  //         medias['main']['name'] = file.name;
  //         medias['main']['path'] = URL.createObjectURL(file);
  //         medias['main']['file'] = file;

  //         setFormData((prev) => ({
  //           ...prev,
  //           medias: {
  //             ...prev.medias,
  //             main: fileData,
  //           },
  //         }));
  //       }

  //       if (fname === "img1") {
  //         let medias = { ...formData.medias };
  //         medias['other_photos']['img1'] = {};
  //         medias['other_photos']['img1']['name'] = file.name;
  //         medias['other_photos']['img1']['path'] = URL.createObjectURL(file);
  //         medias['other_photos']['img1']['file'] = file;
  //         setFormData((prev) => {
  //           return {
  //             ...prev,
  //             medias: medias
  //           }
  //         })
  //       }

  //       if (fname === "img2") {
  //         let medias = { ...formData.medias };
  //         medias['other_photos']['img2'] = {};
  //         medias['other_photos']['img2']['name'] = file.name;
  //         medias['other_photos']['img2']['path'] = URL.createObjectURL(file);
  //         medias['other_photos']['img2']['file'] = file;
  //         setFormData((prev) => {
  //           return {
  //             ...prev,
  //             medias: medias
  //           }
  //         })
  //       }

  //       if (fname === "img3") {
  //         let medias = { ...formData.medias };
  //         medias['other_photos']['img3'] = {};
  //         medias['other_photos']['img3']['name'] = file.name;
  //         medias['other_photos']['img3']['path'] = URL.createObjectURL(file);
  //         medias['other_photos']['img3']['file'] = file;
  //         setFormData((prev) => {
  //           return {
  //             ...prev,
  //             medias: medias
  //           }
  //         })
  //       }
  //     }
  //   }
  // }
  //   const handleFileChange = (e, fname) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   let error = "";

  //   if (!ALLOWED_TYPES.includes(file.type)) {
  //     error = "The file must be a file of type jpg, png, jpeg or pdf";
  //   }

  //   else if (file.size > MAX_FILE_SIZE) {
  //     error = "The file must be less than or equal to 2 MB";
  //   }

  //   // Create file data only once
  //   const fileData = error
  //     ? { name: "", path: "", file: null }
  //     : {
  //         name: file.name,
  //         path: URL.createObjectURL(file),
  //         file: file,
  //       };

  //   setErrors((prev) => ({
  //     ...prev,
  //     [fname === "main" ? "main_image" : fname]: error,
  //   }));

  //   setFormData((prev) => {
  //     let updatedMedias = { ...prev.medias };

  //     if (fname === "main") {
  //       updatedMedias.main = fileData;
  //     } else {
  //       updatedMedias.other_photos = {
  //         ...updatedMedias.other_photos,
  //         [fname]: fileData,
  //       };
  //     }

  //     return {
  //       ...prev,
  //       medias: updatedMedias,
  //     };
  //   });
  // };

  //   const removeImage = (e, fname) => {
  //     // const mediaId =
  //     //   fname === "main"
  //     //     ? formData.medias.main?.media_id
  //     //     : formData.medias.other_photos?.[fname]?.media_id;
  //     const mediaId = formData.medias.other_photos?.[fname]?.media_id;
  //     if (mediaId) {
  //       setDeleteImageId({ mediaId, fname });
  //       setSmallModalShow(true);
  //     } else {
  //       clearImageSlot(fname);
  //     }
  //   };

  //   const clearImageSlot = (fname) => {
  //     const empty = { name: "", path: "", file: null, media_id: null };

  //     // if (fname === "main") {
  //     //   setFormData((prev) => ({
  //     //     ...prev,
  //     //     medias: { ...prev.medias, main: empty },
  //     //   }));
  //     // } else {
  //       setFormData((prev) => ({
  //         ...prev,
  //         medias: {
  //           ...prev.medias,
  //           other_photos: {
  //             ...prev.medias.other_photos,
  //             [fname]: empty,
  //           },
  //         },
  //       }));
  //     // }
  //   };

  const handleFileChange = (e, fname) => {
    const file = e.target.files[0];
    if (!file) return;

    let error = "";

    if (!ALLOWED_TYPES.includes(file.type)) {
      error = "The file must be a file of type jpg, png, jpeg or pdf";
    } else if (file.size > MAX_FILE_SIZE) {
      error = "The file must be less than or equal to 2 MB";
    }

    setErrors((prev) => ({
      ...prev,
      [fname === "main" ? "main_image" : fname]: error,
    }));

    setFormData((prev) => {
      const updatedMedias = { ...prev.medias };

      const oldPath =
        fname === "main"
          ? updatedMedias.main?.path
          : updatedMedias.other_photos?.[fname]?.path;

      if (oldPath) URL.revokeObjectURL(oldPath);

      const fileData = error
        ? { name: "", path: "", file: null, media_id: null }
        : {
          name: file.name,
          path: URL.createObjectURL(file),
          file: file,
          media_id: null,
        };

      if (fname === "main") {
        updatedMedias.main = fileData;
      } else {
        updatedMedias.other_photos = {
          ...(updatedMedias.other_photos || {}),
          [fname]: fileData,
        };
      }

      return {
        ...prev,
        medias: updatedMedias,
      };
    });

    e.target.value = null;
  };

  const removeImage = (e, fname) => {
    const mediaId =
      fname === "main"
        ? formData.medias.main?.media_id
        : formData.medias.other_photos?.[fname]?.media_id;

    if (mediaId) {
      setDeleteImageId({ mediaId, fname });
      setSmallModalShow(true);
    } else {
      clearImageSlot(fname);
    }
  };

  const clearImageSlot = (fname) => {
    const empty = { name: "", path: "", file: null, media_id: null };

    setFormData((prev) => {
      const updatedMedias = { ...prev.medias };

      const oldPath =
        fname === "main"
          ? updatedMedias.main?.path
          : updatedMedias.other_photos?.[fname]?.path;

      if (oldPath) URL.revokeObjectURL(oldPath);

      if (fname === "main") {
        updatedMedias.main = empty;
      } else {
        updatedMedias.other_photos = {
          ...(updatedMedias.other_photos || {}),
          [fname]: empty,
        };
      }

      return {
        ...prev,
        medias: updatedMedias,
      };
    });
  };

  const handleConfirmDeleteClick = () => {
    const { mediaId, fname } = deleteProductImageId;

    props
      .deleteProductMedia(mediaId)
      .then((response) => {
        if (response.status === true) {
          clearImageSlot(fname);
          showSuccessMessage(response.data);
        } else {
          showErrorMessage(response.error);
        }
      })
      .catch((err) => {
        console.error("Error == ", err);
        showErrorMessage("Something Went Wrong!!");
      })
      .finally(() => {
        setSmallModalShow(false);
      });
  };

  const handleFocusOut = (e) => {
    console.log("E >>>>>>>>>>>> ", e.target.name)
    let errObj = { ...errors };
    let fieldValue = e.target.value;
    const productNameRegex = /^[A-Za-z0-9\s\-\/.,&()'+:]{2,150}$/;

    if (e.target.name === "product_name") {
      if (fieldValue === "" || fieldValue === null) {
        errObj.product_name = errorMessages.FIELD_REQUIRED;
      } else if (size(fieldValue) > 150) {
        errObj.product_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else if (!productNameRegex.test(fieldValue)) {
        errObj.product_name = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        errObj.product_name = "";
      }
    }

    if (e.target.name === "price") {
      if (fieldValue === "" || fieldValue === null) {
        errObj.price = errorMessages.FIELD_REQUIRED;
      } else if (size(fieldValue) > 5) {
        errObj.price = 'The field must not be greater than 5 characters.';
      } else if (!/^\d+(\.\d+)?$/.test(fieldValue)) {
        errObj.price = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (fieldValue <= 0) {
        errObj.price = "Price Amount must be greater than zero";
      } else {
        errObj.price = "";
      }

    }


    if (e.target.name === "minimum_order") {
      if (fieldValue !== "" && fieldValue !== null) {
        if (size(fieldValue) > 15) {
          errObj.minimum_order = "The field must not be greater than 15 characters.";
        } else if (!/^\d+(\.\d+)?$/.test(fieldValue)) {
          errObj.minimum_order = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (fieldValue <= 0) {
          errObj.minimum_order = "Minimum Order must be greater than zero";
        } else {
          errObj.minimum_order = "";
        }
      } else {
        errObj.minimum_order = "";
      }
    }

    if (e.target.name === 'reason') {
      validReason();
    }
    setErrors(errObj);
  }

  const updateProductStatus = async (pStatus, reasonTxt = "") => {
    console.log("pStatus >>>>>>> ", pStatus, " >>>>>>>> reasonTxt >>>>>>> ", reasonTxt);
    let data = {
      product_id: id,
      product_status: pStatus,
      reject_reason: reasonTxt
    }
    await props.updateStatus(data).then((response) => {
      console.log("Response ==================== ", response);
      if (response) {
        if (pStatus === 1) {
          setOpenApproveModal(false);
          showSuccessMessage("Product Activated Successfully!");
          fetchProduct(id);
        }
        if (pStatus === 3) {
          setReasonModalShow(false);
          showSuccessMessage("Product Rejected Successfully!");
          fetchProduct(id);
        }
      }
    }).catch((err) => {
      console.log("Error === ", err);
    })
  }

  const approveProduct = () => {
    updateProductStatus(1, "");
  }

  const handleReasonChange = (e) => {
    setReason(e);
  }

  const validReason = () => {
    let errObj = {};
    let errorFlag = 0;
    if (reason === '') {
      errorFlag = 1;
      errObj.reason_max_char = errorMessages.FIELD_REQUIRED;
    }
    if (!isEmpty(reason)) {
      if (size(reason) > 500) {
        errObj.reason_max_char = errorMessages.MAX_CHARACTERS_REACHED;
        errorFlag = 1;
      } else {
        errObj.reason_max_char = "";
        errorFlag = 0;
      }
    }
    setRejectError(errObj);
    return errorFlag;
  }

  const handleAddReasonClick = () => {
    if (!validReason()) {
      updateProductStatus(3, reason);
    }
  }

  const handleProductStatus = (pStatus) => {

    if (pStatus === 1) {
      console.log("approve product")
      setOpenApproveModal(true);
    }

    if (pStatus === 3) {
      console.log("Reject Product")
      setReasonModalShow(true);
    }
  }

  const validateForm = () => {
    let errObj = { ...errors };

    if (isSuperAdmin || isViewer || isOpUser) {
      if (formData.member_id === "" || formData.member_id === null) {
        errObj.member_id = errorMessages.FIELD_REQUIRED;
      } else {
        errObj.member_id = "";
      }
    }

    if (formData.product_name === "" || formData.product_name === null) {
      errObj.product_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.product_name !== "" || formData.product_name !== null) {
      if (size(formData.product_name) > 150) {
        errObj.product_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      }
    } else {
      errObj.product_name = "";
    }

    if (formData.category === "" || formData.category === null) {
      errObj.category = errorMessages.FIELD_REQUIRED;
    } else {
      errObj.category = "";
    }

    if (formData.product_hs_code === "" || formData.product_hs_code === null) {
      errObj.hs_code = errorMessages.FIELD_REQUIRED;
    } else {
      errObj.hs_code = "";
    }

    if (formData.product_origin_country === "" || formData.product_origin_country === null) {
      errObj.product_origin_country = errorMessages.FIELD_REQUIRED;
    } else {
      errObj.product_origin_country = "";
    }

    if (formData.price_type === "fixed") {
      if (!formData.price)
        errObj.price = errorMessages.FIELD_REQUIRED;
      else if (!/^\d+(\.\d+)?$/.test(formData.price))
        errObj.price = errorMessages.IN_VALID_FIELD_FORMAT;
      else if (size(formData.price) > 5)
        errObj.price = 'The field must not be greater than 5 characters.';
      else if (Number(formData.price) <= 0)
        errObj.price = "Price Amount must be greater than zero";
      else
        errObj.price = "";

      errObj.price_unit = !formData.price_unit ? errorMessages.FIELD_REQUIRED : "";
    } else {
      errObj.price = "";
      errObj.price_unit = "";
    }

    if (formData.minimum_order !== "" && formData.minimum_order !== null) {
      if (size(formData.minimum_order) > 15) {
        errObj.minimum_order = "The field must not be greater than 15 characters.";
      } else if (!/^\d+(\.\d+)?$/.test(formData.minimum_order)) {
        errObj.minimum_order = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (formData.minimum_order <= 0) {
        errObj.minimum_order = "Minimum Order must be greater than zero";
      } else {
        errObj.minimum_order = "";
      }
    } else {
      errObj.minimum_order = "";
    }

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = formData.product_desc;

    const trimmedText = tempDiv.textContent.trim();

    if (isEmpty(trimmedText)) {
      errObj.product_desc = errorMessages.FIELD_REQUIRED;
    } else {
      if (trimmedText.length < 100) {
        errObj.product_desc = errorMessages.MIN_LENGTH_100_REQUIRED;
      } else if (trimmedText.length > 2000) {
        errObj.product_desc = errorMessages.MIN_LENGTH_2000_EXCEEDED;
      } else {
        errObj.product_desc = "";
      }
    }

    if (isEmpty(formData.trading_area)) {
      errObj.trading_area = errorMessages.FIELD_REQUIRED;
    } else {
      errObj.trading_area = "";
    }

    // Main image
    const mainFile = formData.medias.main?.file;
    const mainMediaId = formData.medias.main?.media_id;
    const mainPath = formData.medias.main?.path;
    if (!mainFile && !mainPath && !mainMediaId) {
      errObj.main_image = errorMessages.FIELD_REQUIRED;

    } else if (mainFile) {
      if (!ALLOWED_TYPES.includes(mainFile.type)) errObj.main_image = "The file must be a file of type jpg, png, jpeg or pdf";
      else if (mainFile.size > MAX_FILE_SIZE) errObj.main_image = "The file must be less than or equal to 2 MB";
      else errObj.main_image = "";
    } else {
      errObj.main_image = "";
    }

    // Other photos
    ["img1", "img2", "img3"].forEach((key) => {
      const photo = formData.medias.other_photos?.[key];
      if (!photo || (!photo.file && !photo.path)) { errObj[key] = ""; return; }
      if (photo.file) {
        if (!ALLOWED_TYPES.includes(photo.file.type)) errObj[key] = "The file must be a file of type jpg, png, jpeg or pdf";
        else if (photo.file.size > MAX_FILE_SIZE) errObj[key] = "The file must be less than or equal to 2 MB";
        else errObj[key] = "";
      } else {
        errObj[key] = "";
      }
    });

    if (formData.shipping_info) {
      let shippingInfoError = {};
      let shippingError = false;

      forEach(formData.shipping_info, (val, key) => {
        if (!shippingInfoError[key]) shippingInfoError[key] = {};

        const hasCountry = val.country && val.country !== "";
        const hasPorts = val.ports && !isEmpty(val.ports);

        if (size(formData.shipping_info) > 1) {
          if (!hasCountry) {
            shippingInfoError[key]['country'] = errorMessages.FIELD_REQUIRED;
            shippingError = true;
          }
          if (hasCountry && !hasPorts) {
            shippingInfoError[key]['ports'] = errorMessages.FIELD_REQUIRED;
            shippingError = true;
          }
        }

        if (size(formData.shipping_info) <= 1) {
          if (hasCountry && !hasPorts) {
            shippingInfoError[key]['ports'] = errorMessages.FIELD_REQUIRED;
            shippingError = true;
          }
        }
      });

      errObj.shipping_info = shippingError ? shippingInfoError : "";
    }

    setErrors(errObj);
    return Object.keys(errObj).filter(key => errObj[key] !== null && errObj[key] !== undefined && errObj[key] !== "").length > 0;
  }

  const handleSubmit = async (e, pStatus) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    let updatedFormData = {
      ...formData,
      shipping_info: formData.shipping_info.map((info) => {
        const { portList, ...rest } = info;
        return rest;
      })
    };

    let validateResult = await validateForm();

    if (!validateResult) {
      const frmdata = new FormData();

      const data = updatedFormData;

      frmdata.append('product_name', data.product_name);
      frmdata.append('price_type', data.price_type);
      if (data.price_type === "fixed") {
        frmdata.append('price', data.price || "");
        frmdata.append('price_unit', data.price_unit?.value || "");
      }
      frmdata.append('product_desc', data.product_desc);
      frmdata.append('minimum_order', data.minimum_order);
      if (isSuperAdmin || isViewer || isOpUser) {
        frmdata.append('member_id', data.member_id?.value || "");
      } else {
        frmdata.append('member_id', memberCompanyID);
      }

      frmdata.append('category', data.category?.value || "");
      frmdata.append('product_hs_code', data.product_hs_code?.value || "");
      frmdata.append('product_origin_country', data.product_origin_country?.value || "");

      // Array fields
      data.trading_area.forEach((val) => {
        frmdata.append('trading_area[]', val);
      });

      data.shiiping_terms.forEach((val) => {
        frmdata.append('shiiping_terms[]', val);
      });

      // Shipping info (array of objects)
      data.shipping_info.forEach((info, index) => {
        frmdata.append(`shipping_info[${index}][country]`, info.country?.value || "");
        if (info.ports && info.ports.length > 0) {
          info.ports.forEach((port) => {
            frmdata.append(`shipping_info[${index}][ports][]`, port.value);
          });
        }
      });

      // Media files
      if (data.medias?.main?.file) {
        frmdata.append('main_image', data.medias.main.file, data.medias.main.name);
      }

      const otherPhotos = data.medias?.other_photos || {};
      Object.keys(otherPhotos).forEach((key) => {
        if (otherPhotos[key]?.file) {
          // New upload
          frmdata.append(`other_photos[${key}]`, otherPhotos[key].file, otherPhotos[key].name);
        } else if (otherPhotos[key]?.media_id) {
          // Existing server image — tell backend to keep it
          frmdata.append(`existing_photos[${key}]`, otherPhotos[key].media_id);
        }
      });

      frmdata.append("product_status", pStatus);

      await props.updateProduct(id, frmdata).then((response) => {
        if (response.status == true) {
          showSuccessMessage(response.message);
          setTimeout(() => {
            nav(`/${getPrefix(user)}${privateRoutePaths.MY_PRODUCTS.path}`);
          }, 3000);
        }
        if (response.status === false) {
          let errorObj = { ...errors };

          if (response.error.product_name) {
            errorObj.product_name = response.error.product_name[0];
          }

          if (response.error.category) {
            errorObj.category = response.error.category[0];
          }

          if (response.error.price) {
            errorObj.price = response.error.price[0];
          }

          if (response.error.price_unit) {
            errorObj.price_unit = response.error.price_unit[0];
          }

          if (response.error.product_desc) {
            errorObj.product_desc = response.error.product_desc[0];
          }

          if (response.error.product_hs_code) {
            errorObj.hs_code = response.error.product_hs_code[0];
          }

          if (response.error.product_origin_country) {
            errorObj.product_origin_country = response.error.product_origin_country[0];
          }

          if (response.error.trading_area) {
            errorObj.trading_area = response.error.trading_area[0];
          }

          if (response.error.main_image) {
            errorObj.main_image = response.error.main_image[0];
          }
          if (response.error.minimum_order) {
            errorObj.minimum_order = response.error.minimum_order[0];
          }

          setErrors(errorObj);
          setIsSubmitting(false);
        }
      }).catch((err) => {
        console.log("Error === ", err);
        setIsSubmitting(false);
      });
    } else {
      setIsSubmitting(false);
    }

  }

  const fetchHscode = async (val) => {
    await props.getHSCodeSearch(val).then((response) => {
      const hsCodeOptions = map(response, (val) => {
        return {
          label: val.code,
          value: val.id
        }
      });
      setHsCodeList(hsCodeOptions);

    }).catch((err) => {
      console.log("Error ==== ", err);
    });
  }

  const fetchMembers = async (val) => {
    await props.getCompanyListByTradeMode("SUPPLIER", val).then((response) => {
      if (response.status === true) {
        let companies = response.data;
        const companyOptions = map(companies, (company) => {
          return {
            value: company.id,
            label: company.company_list_name,
            email: company.email,
          }
        });
        setMemberList(companyOptions);
      }

    }).catch((err) => {
      console.log("Error ==== ", err);
    });
  }

//   const categoryList = rawCategories;

//   const selectedCategoryOption = (() => {
//     const cat = formData.category;
//     if (cat === undefined || cat === null || cat === "") return null;
//     const key = typeof cat === "object" ? (cat.value ?? cat.id) : cat;
//     return rawCategories.find((o) => String(o.value) === String(key)) || null;
//   })();


//   const formatCategoryLabel = (option) => {
//   const isOther = String(option.rawLabel || option.label || "").trim().toLowerCase() === "other";
//   if (isOther && selectIndustry) {
//     return `Other (${selectIndustry})`;
//   }
//   return option.label;
// };
const categoryList = rawCategories;

  const selectedCategoryOption = (() => {
    const cat = formData.category;
    if (cat === undefined || cat === null || cat === "") return null;
    const key = typeof cat === "object" ? (cat.value ?? cat.id) : cat;
    return rawCategories.find((o) => String(o.value) === String(key)) || null;
  })();


  // LABEL CHANGE ONLY:
  // - "Other" selected  -> shows "Other (ABC)" (ABC = company industry name)
  // - any other category -> shows plain label (nothing added)
  // - dropdown menu list -> always plain label
  const formatCategoryLabel = (option, meta) => {
    const isOther =
      String(option.rawLabel || option.label || "").trim().toLowerCase() === "other";

    if (isOther && meta?.context === "value" && selectIndustry) {
      return `Other (${selectIndustry})`;
    }
    return option.label;
  };

 

  useEffect(() => {
    const fetchDictionaries = async () => {
      await props.getCountryList().then((response) => {
        if (response.status === true) {
          let countries = response.data;
          const countryOptions = map(countries, (country) => {
            return {
              value: country.id,
              label: country.name,
              countryCode: country.iso2,
            }
          });
          setCountryList(countryOptions);
        }
      }).catch((err) => {
        console.log("Error ==== ", err);
      });

      await props.getQuantityUnitList().then((response) => {
        if (!isEmpty(response)) {
          const unitOptions = map(response, (val) => {
            return {
              label: val.unit_code,
              value: val.unit_code
            }
          })
          setUnitList(unitOptions);
        }
      }).catch((err) => {
        console.log("Error ==== ", err);
      });

      await props.getHSCodeList().then((response) => {
        if (!isEmpty(response)) {
          const hsCodeOptions = map(response, (val) => {
            return {
              label: val.code,
              value: val.id
            }
          });
          allHsCodesRef.current = hsCodeOptions;
          setHsCodeList(hsCodeOptions);
        }


      }).catch((err) => {
        console.log("Error === ", err);
      });

      await props.getCategories().then((response) => {
        if (!isEmpty(response)) {
          // const categoryOptions = map(response, (val) => {
          //   return {
          //     label: val.category_name,
          //     value: val.id
          //   }
          // });
          // setCategoryList(categoryOptions);
            setRawCategories(
            map(response, (v) => ({
              label: v.category_name,
              rawLabel: v.category_name,
              value: v.id,
            }))
          );
        }
      });

      await props.getCompanyListByTradeMode("SUPPLIER", "").then((response) => {
        if (response.status === true) {
          let companies = response.data;
          const companyOptions = map(companies, (company) => {
            return {
              value: company.id,
              label: company.company_list_name,
              email: company.email,
            }
          });
          setMemberList(companyOptions);

        }
      }).catch((err) => {
        console.log("Error === ", err);
      })
    }

    fetchDictionaries();
  }, []);

  const fetchProduct = async (id) => {

    try {
      const response = await props.viewProduct(id);
      if (!response.status || isEmpty(response.data)) return;

      const d = response.data[0];
      setReasonTxt(d.reason);
       const industryName = d?.company?.member_industry?.industy_name || "";
      setSelectIndustry(industryName);
      const [companyRes, categoryRes, hsCodeRes, countryRes, unitRes] = await Promise.all([
        d.member_id ? props.getCompanyListByTradeMode("SUPPLIER", d?.company?.member_unique_number) : Promise.resolve(null),
        props.getCategories(),
        props.getHSCodeID(d.hs_code_id),
        props.getCountryList(),
        props.getQuantityUnitList(),
      ]);

      let selectedCompany = null;
      if (companyRes?.status === true) {
        const opts = map(companyRes.data, (c) => ({
          value: c.id,
          label: c.company_list_name,
          email: c.email,
        }));
        selectedCompany = opts.find((c) => c.value === d.member_id) ?? null;
      }

      // let selectedCategory = null;
      // if (!isEmpty(categoryRes)) {
      //   const opts = map(categoryRes, (v) => ({
      //     label: v.category_name,
      //     rawLabel: v.category_name,
      //     value: v.id,
      //   }));
      //   selectedCategory = opts.find((c) => c.value === d.category_id) ?? null;
      // }
       let selectedCategory = null;
      if (!isEmpty(categoryRes)) {
        const opts = map(categoryRes, (v) => ({
          label: v.category_name,
          rawLabel: v.category_name,
          value: v.id,
        }));
        selectedCategory = opts.find((c) => c.value === d.category_id) ?? null;
      }

      let selectedHsCode = null;
      if (!isEmpty(hsCodeRes)) {
        const opts = map(hsCodeRes, (v) => ({ label: v.code, value: v.id }));
        setHsCodeList(opts);
        selectedHsCode = opts.find((c) => c.value === d.hs_code_id) ?? null;
      }

      let selectedOriginCountry = null;
      let countryOptions = [];
      if (countryRes?.status === true) {
        countryOptions = map(countryRes.data, (c) => ({
          value: c.id, label: c.name, countryCode: c.iso2,
        }));
        setCountryList(countryOptions);
        selectedOriginCountry =
          countryOptions.find((o) => o.value == d.product_country_id) ?? null;
      }
      let selectedUnit = null;
      if (!isEmpty(unitRes)) {
        const opts = map(unitRes, (v) => ({ label: v.unit_code, value: v.unit_code }));
        setUnitList(opts);
        selectedUnit = opts.find((u) => u.value === d.price_unit) ?? null;
      }

      let tradingArea = [];
      if (d.trading_area) {
        if (Array.isArray(d.trading_area)) {
          tradingArea = d.trading_area.filter(Boolean);
        } else {
          tradingArea = d.trading_area
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
        }
      }


      let mainImage = { name: "", path: "", file: null, media_id: null };
      let other_photos = {};

      if (!isEmpty(d.product_medias)) {
        const mainMedia = d.product_medias.find((m) => m.photo_type === "MAIN");
        const otherMedias = d.product_medias.filter((m) => m.photo_type !== "MAIN");

        if (mainMedia?.photo_detail) {
          mainImage = {
            name: mainMedia.photo_detail,
            path: BASE_URL + mainMedia.photo_detail,
            file: null,
            media_id: mainMedia.id,
          };
        }

        ["img1", "img2", "img3"].forEach((key, i) => {
          if (otherMedias[i]?.photo_detail) {
            other_photos[key] = {
              name: otherMedias[i].photo_detail,
              path: BASE_URL + otherMedias[i].photo_detail,
              file: null,
              media_id: otherMedias[i].id,
            };
          }
        });
        // otherMedias.forEach((media) => {
        //   const key = media.slot; // "img1", "img2", or "img3"
        //   if (key && media.photo_detail) {
        //     other_photos[key] = {
        //       name:     media.photo_detail,
        //       path:     BASE_URL + media.photo_detail,
        //       file:     null,
        //       media_id: media.id,
        //     };
        //   }
        // });


      }

      let shippingInfo = [{ country: "", ports: [], portList: [], port_row_ids: [] }];

      if (!isEmpty(d.product_ports)) {

        const groupedByCountry = d.product_ports.reduce((acc, row) => {
          const cid = String(row.country_id);
          if (!acc[cid]) acc[cid] = [];
          acc[cid].push(row);
          return acc;
        }, {});

        const countryIds = Object.keys(groupedByCountry);

        const portResponses = await Promise.all(
          countryIds.map((cid) =>
            props.getPortsByCountry(Number(cid)).catch(() => [])
          )
        );

        shippingInfo = countryIds.map((cid, i) => {
          const rows = groupedByCountry[cid];

          const portList = map(portResponses[i] ?? [], (p) => ({
            label: p.name,
            value: p.id,
          }));

          const countryOption =
            countryOptions.find((c) => c.value === Number(cid)) ?? null;

          const selectedPorts = uniqBy(
            rows
              .filter((row) => row.port)
              .map((row) => ({
                label: row.port.name,
                value: row.port.id,
              })),
            'value'
          );

          const portRowIds = [...new Set(rows.map((row) => row.id))];

          return {
            country: countryOption,
            ports: selectedPorts,
            portList,
            port_row_ids: portRowIds,
          };
        });
      }

      setProductDescription(d.product_description ?? d.product_desc ?? "");

      let shippingTermsSelected = [];
      if (!isEmpty(d.product_shipping)) {
        shippingTermsSelected = map(d.product_shipping, (s) => s.shipping_term).filter(Boolean);
      }

      setFormData((prev) => ({
        ...prev,
        member_id: selectedCompany,
        product_name: d.product_name ?? "",
        category: selectedCategory, 
        product_hs_code: selectedHsCode,
        product_origin_country: selectedOriginCountry,
        price_type: d.price_type ?? "fixed",
        price: d.price_type === "fixed" ? (d.price ?? "") : "",
        price_unit: d.price_type === "fixed" ? selectedUnit : null,
        minimum_order: d.minimum_order ?? "",
        trading_area: tradingArea,
        shiiping_terms: shippingTermsSelected,
        product_desc: d.product_desc ?? d.product_description ?? "",
        shipping_info: shippingInfo,
        medias: {
          main: mainImage,
          other_photos: other_photos,
        },
        product_status: d.status
      }));

    } catch (err) {
      console.log("fetchProduct error:", err);
    }
  };

  useEffect(() => {
    fetchProduct(id);
  }, [id]);

  return (
    <div className="data-table-main">

      <SubHeader layer1="My Products" layer2="List" layer3="Update" pageName="Update Product" subTitle="" clickable={{
        layer1: "",
        layer2: "",
        layer3: ""
      }} />

      {/* <form onSubmit={handleSubmit} className="bg-white shadow rounded p-4 mb-4"> */}
      <div className="bg-white shadow rounded p-4 mb-4">

        <div class=" pb-3 border-bottom d-flex justify-content-between">
          <h4 class="head-office-text  ">Product Basic Details</h4>
          <div className="button-wrapes note-wrape">
            {
              formData.product_status === 3 && <p>
                <b>Rejected :</b>
                {
                  formData.product_status === 3 ? ` ${reasonTxt} ` : ""
                }
              </p>
            }


            {
              ((isSuperAdmin || isOpUser) && (formData.product_status === 2 || formData.product_status === 3)) &&
              <ButtonAdminpanel
                type="button"
                className="mx-2 approve-color custom-padding"
                // onClick={() => handleCompanyStatusClick(1)}
                //onClick={() => handleAssignPlan()}
                onClick={() => handleProductStatus(1)}
              >
                <i className="fa fa-check px-1" aria-hidden="true"></i>Approve
              </ButtonAdminpanel>
            }
            {
              ((isSuperAdmin || isOpUser) && (formData.product_status === 2 || formData.product_status === 1)) &&
              <ButtonAdminpanel
                type="button"
                className=" mx-2 reject-color custom-padding"
                // onClick={() => handleCompanyStatusClick(4, 'this is reason')}
                //onClick={() => openReasonModal()}
                onClick={() => handleProductStatus(3)}
              >

                <svg id="fi_2822680" fill="#ffffff" className="mx-1 pb-1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18" xmlns="http://www.w3.org/2000/svg"><path d="m506.607 104.396-99.996-100.002c-2.813-2.814-6.629-4.394-10.607-4.394h-230.004c-24.813 0-45 20.187-45 45v197.838c-67.406 7.486-120 64.793-120 134.162 0 74.439 60.561 135 135 135h330c24.813 0 45-20.187 45-45v-351.997c0-3.979-1.58-7.793-4.393-10.607zm-95.607-53.183 32.59 32.591 16.196 16.196h-48.786zm-380 325.787c0-57.897 47.103-105 105-105s105 47.103 105 105-47.103 105-105 105-105-47.103-105-105zm435 105h-245.251c26.963-21.805 45.389-53.759 49.414-90h155.837c8.284 0 15-6.716 15-15s-6.716-15-15-15h-155.838c-2.446-22.02-10.204-42.459-21.968-60h177.806c8.284 0 15-6.716 15-15s-6.716-15-15-15h-205.251c-19.521-15.786-43.511-26.248-69.749-29.162v-197.838c0-8.271 6.729-15 15-15h215v85c0 8.284 6.716 15 15 15h85v337c0 8.271-6.729 15-15 15z"></path><path d="m426 182h-220c-8.284 0-15 6.716-15 15s6.716 15 15 15h220c8.284 0 15-6.716 15-15s-6.716-15-15-15z"></path><path d="m170.394 432.606c2.928 2.929 6.767 4.394 10.606 4.394s7.678-1.465 10.606-4.394c5.858-5.857 5.858-15.355 0-21.213l-34.393-34.393 34.394-34.394c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-34.394 34.394-34.394-34.394c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213l34.394 34.394-34.394 34.394c-5.858 5.857-5.858 15.355 0 21.213 2.929 2.928 6.768 4.393 10.607 4.393s7.678-1.465 10.606-4.394l34.394-34.393z"></path></svg>
                Reject
              </ButtonAdminpanel>
            }


          </div>
        </div>
        {
          (isSuperAdmin || isViewer || isOpUser) && <div className="row pt-3">
            <div className="col-xl-4">
              <label className='profile-text'>Company Name<span className='text-danger'>{' '}*</span></label>

              <div className="d-flex">
                <div className="w-100">
                  <ReactSelect
                    options={memberList}
                    onInputChange={handleMemberInputChange}
                    // className={`${props.isDisable || props.disableProfile ? `drop-down-disable-multi` : ` `}`}
                    labelledBy="Select"
                    name="member_id"
                    value={formData.member_id}
                    classNamePrefix={"react-select"}
                    onChange={(e) => handleSelectChange(e, 'member_id')}
                    noOptionsMessage={() => "No Company Found"}
                    filterOption={customMemberFilter}
                  />
                  {errors.member_id && (
                    <span
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.member_id}
                    </span>
                  )}
                </div>

              </div>

            </div>
          </div>
        }


        <div className={(isSuperAdmin || isViewer || isOpUser) ? "row" : "row pt-3"}>

          <div className='col-xl-4 py-2'>
            <label className='profile-text'>Product Name<span className='text-danger'>{' '}*</span></label>

            <div className="d-flex">
              <div className="w-100">
                <InputField
                  placeholder={"Enter your product name"}
                  className={"input-error-border mr-input"}
                  autoComplete="off"
                  value={formData.product_name}
                  name="product_name"
                  onChange={handleInputChange}
                  onBlur={handleFocusOut}
                  disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                ></InputField>
                {errors.product_name && (
                  <span
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >
                    {errors.product_name}
                  </span>
                )}
              </div>

            </div>
          </div>

          <div className='col-xl-4 py-2'>

            <label className='profile-text'>Product Category<span className='text-danger'>{' '}*</span></label>
            <DropDown
              className={"input-error-border"}
              name="category"
              options={categoryList}
              // value={formData.category}
              value={selectedCategoryOption}
              onChange={(e) => handleSelectChange(e, 'category')}
              formatOptionLabel={formatCategoryLabel}
              // isDisabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
              isDisabled={isPreKYCUser || isEndUser}

            >
            </DropDown>
            {errors.category && (
              <span
                className="invalid-feedback"
                style={{ display: "block" }}
              >
                {errors.category}
              </span>
            )}
          </div>

          <div className="col-xl-4 py-2">
            <label className='profile-text'>Product HSN Code<span className='text-danger'>{' '}*</span></label>

            <ReactSelect
              options={hscodeList}
              onInputChange={handlehscodeInputChange}
              // className={`${props.isDisable || props.disableProfile ? `drop-down-disable-multi` : ` `}`}
              labelledBy="Select"
              name="product_hs_code"
              value={formData.product_hs_code}
              classNamePrefix={"react-select"}
              onChange={(e) => handleSelectChange(e, 'hs_code')}
              noOptionsMessage={() => "No Hs Code Found"}
              filterOption={customFilter}
              isDisabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
            />
            {errors.hs_code && (
              <span
                className="invalid-feedback"
                style={{ display: "block" }}
              >
                {errors.hs_code}
              </span>
            )}
          </div >

          <div className='col-xl-4 py-2'>

            <label className='profile-text'>Product Origin Country<span className='text-danger'>{' '}*</span></label>
            <DropDown
              className={"input-error-border"}
              name="country"
              options={countryList}
              value={formData.product_origin_country}
              onChange={(e) => handleSelectChange(e, 'origin_country')}
              isDisabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
            >
            </DropDown>
            {errors.product_origin_country && (
              <span
                className="invalid-feedback"
                style={{ display: "block" }}
              >
                {errors.product_origin_country}
              </span>
            )}
          </div>

          <div className='col-xl-4 py-2'>
            <label className='profile-text'>Price Type <span className='text-danger'>*</span></label>
            <div className='d-flex'>
              <div className='d-inline'>
                <RadioButtonField
                  name="priceSelection"
                  value="fixed"
                  checked={formData.price_type === "fixed"}
                  onChange={handlePriceTypeChange}
                  disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                />
                <label>Fixed</label>
              </div>
              <div className='d-inline'>
                <RadioButtonField
                  name="priceSelection"
                  value="requestQuote"
                  checked={formData.price_type === "requestQuote"}
                  onChange={handlePriceTypeChange}
                  disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                />
                <label>Request on Quote</label>
              </div>
            </div>
          </div>

          {
            formData.price_type === 'fixed' && (
              <div className='col-xl-2 py-2'>
                <label className='profile-text'>Price Amount<span className='text-danger'>{' '}*</span></label>
                <div className="w-100">
                  <InputField
                    placeholder={"Enter Your Product Price"}
                    className={"input-error-border mr-input"}
                    //disabled={formData.price_type === "quote"}
                    value={formData.price_type === "quote" ? "" : formData.price}
                    //onChange={(e) => setPrice(e.target.value)}
                    onChange={handleInputChange}
                    onBlur={handleFocusOut}
                    name="price"
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  />
                  {errors.price && (
                    <span
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.price}
                    </span>
                  )}
                </div>
              </div>
            )
          }

          {
            formData.price_type === 'fixed' && (

              <div className="col-xl-2 py-2">
                <label className='profile-text'>Product Unit<span className='text-danger'>{' '}*</span></label>
                <DropDown
                  className={"input-error-border"}
                  name="product_unit"
                  options={unitList}
                  onChange={(e) => handleSelectChange(e, 'price_unit')}
                  value={formData.price_unit}
                  isDisabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                >
                </DropDown>
                {errors.price_unit && (
                  <span
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >
                    {errors.price_unit}
                  </span>
                )}
              </div>
            )
          }

          <div className="col-xl-12 py-2">
            <label className='profile-text'>Product Description <span className='text-danger'>{' '}*</span></label>
            <div className={`input-wrape`}>
              <div className="input-pad inquiry-ck-editer">
                <div className={`ck-editor-wrapper ${errors.product_desc ? "ck-error" : ""}`}>
                  <CKEditor
                    editor={ClassicEditor}
                    data={product_description || ''}
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                    config={{
                      toolbar: {
                        items: ['bold', 'italic', 'underline', 'fontSize', 'bulletedList'],
                      },
                      fontSize: {
                        options: [10, 12, 14, 'default', 18, 20, 22, 24, 30],
                        supportAllValues: false,
                      },
                      language: 'en',
                      plugins: [
                        Essentials,
                        Bold,
                        Italic,
                        Underline,
                        FontSize,
                        Paragraph,
                        List,
                      ],
                      licenseKey: "GPL",

                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setFormData(prev => ({
                        ...prev,
                        product_desc: data,
                      }));
                    }}
                    onBlur={(event, editor) => {
                      const data2 = editor.getData();

                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = data2;

                      const trimmedText = tempDiv.textContent.trim();

                      if (isEmpty(trimmedText)) {
                        let er = { ...errors };
                        er.product_desc = errorMessages.FIELD_REQUIRED;
                        setErrors(er);
                      } else {
                        let er = { ...errors };
                        if (trimmedText.length < 100) {

                          er.product_desc = errorMessages.MIN_LENGTH_100_REQUIRED;
                          setErrors(er);
                        } else if (trimmedText.length > 2000) {

                          er.product_desc = errorMessages.MIN_LENGTH_2000_EXCEEDED;
                          setErrors(er);
                        } else {
                          er.product_desc = "";
                          setErrors(er);
                        }

                      }
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "150px",
                          editor.editing.view.document.getRoot()
                        );
                        writer.setStyle(
                          "width",
                          "100",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </div>
                {errors.product_desc && (
                  <span
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >
                    {errors.product_desc}
                  </span>
                )}
              </div>
            </div>
          </div>

        </div >

        <div className="product-media-wrape mb-4">
          <div class="py-3 mb-2 border-bottom">
            <h4 class="head-office-text  ">Product Medias</h4>
          </div>

          <div className="row py-2" >
            {/* <label className='profile-text'>Product Photos</label> */}
            <div className='col-xxl-3 col-xl-3 col-md-3'>
              <div className="d-flex">
                <div className="w-100">
                  <p className="mb-1"><b>Main Image <span className='text-danger'>{' '}*</span></b></p>
                  <div className="img-wrape main-img">
                    <input type="file" ref={mainImgRef} autoComplete="off"
                      accept="image/*" onChange={(e) => handleFileChange(e, 'main')} disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false} />

                    <img src={formData.medias.main?.path ? formData.medias.main.path : ImgUpload} alt="main-product-image" onClick={(e) => handleImgClick(e, 'main')} />

                    {/* {formData.medias.main?.path && <div onClick={(e) => removeImage(e, "main")} className="delete-icon">
                      <i className="fa-regular fa-trash-can text-danger"></i>
                    </div>
                    } */}
                  </div>

                  {errors.main_image && (
                    <span
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.main_image}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xxl-9 col-xl-9 col-lg-12 other-img-wrape">
              <div className="row">
                <div className="col-xxl-12">
                  <p className="mb-1"><b>Other Images</b></p>
                </div>
                <div className='col-xxl-4 col-xl-4 col-md-6'>
                  <div className="d-flex">
                    <div className="w-100">
                      <div className="img-wrape">
                        <input type="file" ref={fileInputRef1} autoComplete="off"
                          accept="image/*" onChange={(e) => handleFileChange(e, 'img1')} disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false} />

                        <img src={formData.medias['other_photos'] && formData.medias['other_photos']['img1'] && formData.medias['other_photos']['img1']['path'] ? formData.medias['other_photos']['img1']['path'] : ImgUpload} alt="main-product-image" onClick={(e) => handleImgClick(e, 'img1')} />

                        {
                          formData.medias['other_photos'] && formData.medias['other_photos']['img1'] && formData.medias['other_photos']['img1']['path'] && <div onClick={(e) => removeImage(e, "img1")} className="delete-icon">
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        }
                      </div>

                      {errors.img1 && (
                        <span
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.img1}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-xl-4 col-md-6'>
                  <div className="d-flex">
                    <div className="w-100">
                      <div className="img-wrape">
                        <input type="file" ref={fileInputRef2} autoComplete="off"
                          accept="image/*" onChange={(e) => handleFileChange(e, 'img2')} disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false} />

                        <img src={formData.medias['other_photos'] && formData.medias['other_photos']['img2'] && formData.medias['other_photos']['img2']['path'] ? formData.medias['other_photos']['img2']['path'] : ImgUpload} alt="main-product-image" onClick={(e) => handleImgClick(e, 'img2')} />

                        {
                          formData.medias['other_photos'] && formData.medias['other_photos']['img2'] && formData.medias['other_photos']['img2']['path'] && <div onClick={(e) => removeImage(e, "img2")} className="delete-icon">
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        }
                      </div>

                      {errors.img2 && (
                        <span
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.img2}
                        </span>
                      )}

                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-xl-4 col-md-6'>
                  <div className="d-flex">
                    <div className="w-100">
                      <div className="img-wrape">
                        <input type="file" ref={fileInputRef3} autoComplete="off"
                          accept="image/*" onChange={(e) => handleFileChange(e, 'img3')} disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false} />
                        <img src={formData.medias['other_photos'] && formData.medias['other_photos']['img3'] && formData.medias['other_photos']['img3']['path'] ? formData.medias['other_photos']['img3']['path'] : ImgUpload} alt="main-product-image" onClick={(e) => handleImgClick(e, 'img3')} />

                        {
                          formData.medias['other_photos'] && formData.medias['other_photos']['img3'] && formData.medias['other_photos']['img3']['path'] && <div onClick={(e) => removeImage(e, "img3")} className="delete-icon">
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        }
                      </div>

                      {errors.img3 && (
                        <span
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors.img3}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="py-3 border-bottom">
          <h4 class="head-office-text  ">Product Shipping Details</h4>
        </div>

        <div className="row">

          {/* <div className="col-xl-4 py-2">
            <label className='profile-text'>Trading Area <span className='text-danger'>{' '}*</span></label>

            <div className='d-flex mt-2'>
              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "domestic")}
                    //checked={isChecked}
                    name="trading_area"
                    label={"Domestic"}

                  ></CheckBox>
                </div>
                <label>Domestic</label>
              </div>

              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "international")}
                    label={"International"}
                    name="trading_area"
                  ></CheckBox>
                </div>
                <label>International</label>
              </div>

            </div>
            {errors.trading_area && (
              <span
                className="invalid-feedback"
                style={{ display: "block" }}
              >
                {errors.trading_area}
              </span>
            )}
          </div> */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Trading Area <span className="text-danger"> *</span>
            </label>
            <div className="d-flex mt-2">
              {["domestic", "international"].map((area) => (
                <div key={area} className="d-flex me-3">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, area)}
                    checked={formData.trading_area.includes(area)}
                    name="trading_area"
                    label={area}
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  />
                  <label className="ms-1">
                    {area.charAt(0).toUpperCase() + area.slice(1)}
                  </label>
                </div>
              ))}
            </div>
            {errors.trading_area && (
              <span className="invalid-feedback" style={{ display: "block" }}>
                {errors.trading_area}
              </span>
            )}
          </div>

          <div className="col-xl-4 py-2">
            <lable className='profile-text'>Shipping Type</lable>
            <div className='d-flex mt-2'>
              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "EXW")}
                    checked={formData.shiiping_terms.includes("EXW")}
                    label={"EXW"}
                    name="shipping_type"
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  ></CheckBox>
                </div>
                <label>EXW</label>
              </div>

              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "FOB")}
                    checked={formData.shiiping_terms.includes("FOB")}
                    label={"FOB"}
                    name="shipping_type"
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  ></CheckBox>
                </div>
                <label>FOB</label>
              </div>

              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "FAS")}
                    checked={formData.shiiping_terms.includes("FAS")}
                    label={"FAS"}
                    name="shipping_type"
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  ></CheckBox>
                </div>
                <label>FAS</label>
              </div>

              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "DPU")}
                    checked={formData.shiiping_terms.includes("DPU")}
                    label={"DPU"}
                    name="shipping_type"
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  ></CheckBox>
                </div>
                <label>DPU</label>
              </div>

              <div className="d-flex">
                <div className="d-inline">
                  <CheckBox
                    onChange={(e) => handleCheckChange(e, "DDP")}
                    checked={formData.shiiping_terms.includes("DDP")}
                    label={"DDP"}
                    name="shipping_type"
                    disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  ></CheckBox>
                </div>
                <label>DDP</label>
              </div>
            </div>
          </div>

          <div className='col-xl-4 py-2'>
            <label className='profile-text'>Minimum Order<span className='text-danger'>{' '}</span></label>
            <div className="w-100">
              <InputField
                placeholder={"Enter Your Minimum Order"}
                className={"input-error-border mr-input"}
                value={formData.minimum_order ? formData.minimum_order : ""}
                onChange={handleInputChange}
                onBlur={handleFocusOut}
                name="minimum_order"
                disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
              />
              {errors.minimum_order && (
                <span
                  className="invalid-feedback"
                  style={{ display: "block" }}
                >
                  {errors.minimum_order}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="row">

          {
            map(formData.shipping_info, (sInfo, indx) => {
              return (<>
                <div className="col-xl-4 py-3" key={indx}>
                  <label className='profile-text'>Port Of Country</label>

                  <DropDown
                    className={"input-error-border"}
                    name="port_of_country"
                    options={countryList}
                    isMulti={false}
                    value={formData.shipping_info[indx]['country'] ? formData.shipping_info[indx]['country'] : null}
                    onChange={(e) => handleCountryChange(e, indx)}
                    isClearable={true}
                    isDisabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  />
                  {errors.shipping_info && errors.shipping_info[indx] && errors.shipping_info[indx]['country'] && (
                    <span
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.shipping_info[indx]['country']}
                    </span>
                  )}
                </div>

                <div className="col-xl-4 py-3">
                  <label className='profile-text'>Port Of Shipping</label>

                  <DropDown
                    className={"input-error-border"}
                    name="shipping_port"
                    options={formData.shipping_info[indx]['portList'] ? formData.shipping_info[indx]['portList'] : []}
                    isMulti={true}
                    value={formData.shipping_info[indx]['ports'] ? formData.shipping_info[indx]['ports'] : []}
                    onChange={(e) => handlePortChange(e, indx)}
                    isDisabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}
                  >
                  </DropDown>
                  {errors.shipping_info && errors.shipping_info[indx] && errors.shipping_info[indx]['ports'] && (
                    <span
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.shipping_info[indx]['ports']}
                    </span>
                  )}
                </div>

                <div className="col-xl-4 py-3">
                  <div className="d-flex" style={{ "marginTop": "30px" }}>
                    <button type="button" onClick={handleAddClick} className="btn outlines" disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}>
                      <i className="fa fa-plus"></i>
                    </button>
                    <button type="button" onClick={(e) => handleRemoveClick(e, indx)} className="btn outlines" disabled={((isPreKYCUser || isEndUser) && formData.product_status == 2) ? true : false}>
                      <i className="fa fa-minus"></i>
                    </button>
                  </div>
                </div>
              </>)
            })
          }

        </div>

        {
          ((isPreKYCUser || isEndUser) && formData.product_status == 2) ? <></> : <div className="col-xxl-12 text-end border-top mt-5">
            {
              ((isPreKYCUser || isEndUser) && (formData.product_status === 0 || formData.product_status === 3)) && <ButtonAdminpanel className="mt-3 mx-3" type={"button"} disabled={isSubmitting} onClick={(e) => handleSubmit(e, formData.product_status)}>Save</ButtonAdminpanel>
            }

            {
              (isPreKYCUser || isEndUser) ? <ButtonAdminpanel className="mt-3" type={"button"} disabled={isSubmitting} onClick={(e) => handleSubmit(e, 2)}>Send For Approval</ButtonAdminpanel> : <>
                <ButtonAdminpanel className="mt-3" type={"button"} disabled={isSubmitting} onClick={(e) => handleSubmit(e, formData.product_status)}>Update Product</ButtonAdminpanel>
                <ButtonAdminpanel className="mt-3 mx-3" type={"button"} disabled={isSubmitting} onClick={(e) => handleSubmit(e, 1)}>Update & Activate Product</ButtonAdminpanel>
              </>
            }

          </div>
        }

        {/* </form > */}
      </div>

      <SmallPopup
        title="Delete Image"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={handleConfirmDeleteClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete Image?</div>
        </div>

      </SmallPopup>

      <SmallPopup
        title="Approve Product"
        smallmodalShow={openApproveModal}
        setSmallModalShow={setOpenApproveModal}
        onSubmit={approveProduct}
        closeButtonLabel="Cancel"
        okButtonLabel="Approve">
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to approve this Product?</div>
        </div>
      </SmallPopup>

      <MediumPopup
        title="Please provide the reason"
        mediummodalShow={reasonModalShow}
        setMediumModalShow={setReasonModalShow}
        onSubmit={handleAddReasonClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Add"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">
            <TextAreaField name="reason" value={reason} onChange={handleReasonChange} maxLength={500 + 1} onBlur={handleFocusOut} />
            {reject_error.reason_max_char && (
              <p
                className="invalid-feedback"
                style={{ display: "block" }}
              >
                {reject_error.reason_max_char}
              </p>
            )}
          </div>
        </div>

      </MediumPopup>
      {/* <ToastContainer /> */}

    </div >

  )

}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    viewProduct: (id) => dispatch(getProduct(id)),
    getCountryList: () => dispatch(countryList()),
    getQuantityUnitList: () => dispatch(getQuantityUnitList()),
    getHSCodeList: () => dispatch(getHSCodeList()),
    getHSCodeSearch: (search_txt) => dispatch(getHSCodeSearchList(search_txt)),
    getCategories: () => dispatch(getCategories()),
    getPortsByCountry: (country_id) => dispatch(getPortsByCountry(country_id)),
    getCompanyListByTradeMode: (trade_mode, searchTxt) => dispatch(getCompanyListByTradeMode(trade_mode, searchTxt)),
    getHSCodeID: (hs_code_id) => dispatch(getSelectedHSCodeListByIdList(hs_code_id)),
    updateProduct: (id, formData) => dispatch(updateProduct(id, formData)),
    deleteProductMedia: (mediaId) => dispatch(deleteProductMedia(mediaId)),
    updateStatus: (data) => dispatch(updateproductStatus(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
